import { connect } from 'react-redux';
import Content from '../Content';

export default connect(
  state =>
    ({products: state.products}),
  null
)(Content);

